import { z } from 'zod';
import { inferApiResultSchema } from './infer-api';

export const DemandReviewerSchema = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  demandId: z.number(),
  reviewerId: z.string().min(1).max(50),
  createdBy: z.string().max(50),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type DemandReviewerDto = z.infer<typeof DemandReviewerSchema>;

export const GetDemandReviewersResponseSchema = inferApiResultSchema(z.array(DemandReviewerSchema));
export type GetDemandReviewersResponseDto = z.infer<typeof GetDemandReviewersResponseSchema>;

export const CreateDemandReviewerSchema = DemandReviewerSchema.pick({
  reviewerId: true,
});
export type CreateDemandReviewerDto = z.infer<typeof CreateDemandReviewerSchema>;

export const CreateDemandReviewerResponseSchema = inferApiResultSchema(DemandReviewerSchema);
export type CreateDemandReviewerResponseDto = z.infer<typeof CreateDemandReviewerResponseSchema>;

export const UpdateDemandReviewerSchema = CreateDemandReviewerSchema.partial().refine(
  ({ reviewerId }) => reviewerId !== undefined,
  { message: 'At least one reviewer field must be provided' },
);
export type UpdateDemandReviewerDto = z.infer<typeof UpdateDemandReviewerSchema>;

export const UpdateDemandReviewerResponseSchema = inferApiResultSchema(DemandReviewerSchema);
export type UpdateDemandReviewerResponseDto = z.infer<typeof UpdateDemandReviewerResponseSchema>;
